import _ from 'lodash';

export const getCompanyLabel = company => {
  if (!_.get(company, 'products.length', null)) return '';

  let label = '';

  const sectors = _.uniq(_.flattenDeep(company.products.map(p => p.sectors)));
  const solutions = _.uniq(
    _.flattenDeep(company.products.map(p => p.solutions))
  );

  if (sectors.length) label += sectors[0].name;
  if (solutions.length) label += ` | ${solutions[0].name}`;
  if (solutions.length > 1) label += ` + ${solutions.length - 1}`;

  return label;
};
